import { Button, FormControl, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import "./update-password.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import toaster from "../../../../utility/toaster/toaster";
import { getRequest, postRequest, putRequest, putRequest2 } from "../../../../services/api/axios_api_Request";
import Loader from "../../../components/loader/Loader";
import { useLocation } from "react-router-dom";

const useQuery = () => new URLSearchParams(useLocation().search);

export default function UpdatePassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const query = useQuery();
  const token = query.get("token");

  console.log("token from url", token);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) {
      toaster("error", "Passwords do not match.");
      return;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}`,
        "Access-Control-Allow-Credentials": "true",
      },
      withCredentials: true, // This is important to include cookies in requests
    };
    try {
      const res = await putRequest2(`/public/update-password`, { newPassword, token });
      if (res.status === 200) {
        toaster("success", "Password updated successfully.");
        setIsPasswordUpdated(true);
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      }else{
        toaster("error",res?.data?.message)
      }

    } catch (error) {
      toaster("error", error.response?.data?.message || "Error updating password.");
    }
  };

  return (
    <>
      <Grid className="updatePassword-main-container">
        <Grid className="name-logo">
          <h1 className="heading-name-1">
            PACE<span className="heading-name-2">APPS</span>
          </h1>
        </Grid>
        {isPasswordUpdated ? (
          <Loader />
        ) : (
          <Grid className="updatePassword-form-container">
            <Grid className="updatePassword-form-wrapper">
              <form onSubmit={handleSubmit}>
                <Stack spacing={1}>
                  <Grid className="form-heading">
                    <h2>Update Password</h2>
                  </Grid>

                  <Grid className="form-field">
                    <FormControl className="form-label" htmlFor="new-password" variant="outlined">
                      New Password:
                    </FormControl>
                    <TextField
                      required
                      type={showPassword ? "text" : "password"}
                      id="new-password"
                      placeholder="Enter new password"
                      onChange={(e) => setNewPassword(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <span
                              className="toggle-eye"
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}>
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </span>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid className="form-field">
                    <FormControl className="form-label" htmlFor="confirm-password" variant="outlined">
                      Confirm Password:
                    </FormControl>
                    <TextField
                      required
                      type={showPassword ? "text" : "password"}
                      id="confirm-password"
                      placeholder="Confirm new password"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <span
                              className="toggle-eye"
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}>
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </span>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid className="form-button">
                    <Button type="submit" variant="contained">
                      Update Password
                    </Button>
                    <span className="arrowback-update-page" onClick={() => navigate("/login")}>
                      <ArrowBack />
                      Back to login
                    </span>
                  </Grid>
                </Stack>
              </form>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}
